import createInfoBarMessageViewStateFactory from './createInfoBarMessageViewStateFactory';
import { getComposeHostItemIndex } from 'owa-addins-core';
import { ComposeViewState } from 'owa-mail-compose-store';
import * as ComposeInfoBarHandlers from 'owa-mail-compose-store/lib/utils/infoBarHandlers';

export const addNotificationMessage = (viewState: ComposeViewState) => (messageId: string) => {
    ComposeInfoBarHandlers.infoBarAddHandler(viewState)(
        messageId,
        createInfoBarMessageViewStateFactory(
            getComposeHostItemIndex(viewState.composeId),
            messageId,
            removeNotificationMessage(viewState)
        )
    );
};

export const removeNotificationMessage = (viewState: ComposeViewState) => (messageId: string) => {
    ComposeInfoBarHandlers.infoBarRemoveHandler(viewState)([messageId]);
};

export const getNotificationMessageIds = (viewState: ComposeViewState) => (): string[] => {
    return ComposeInfoBarHandlers.infoBarGetIdsHandler(viewState)();
};
